import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import ViewInquiry from "../../VIewInquiry/ViewInquiry";
import "./InquiryRow.css";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import ViewReplies from "../../VIewInquiry/ViewReplies";
import Modal from "react-bootstrap/es/Modal";
import noRecords from "../../../../assets/img/norecord.png";
import newIcon from "../../../../assets/img/icons8-new-48.png";

class InquiryRow extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lastElement:[],
            replies:[],
            statusCode: '',
            show: false,

        };
        this.truncate = this.truncate.bind(this);
        this.getInquiryStatus = this.getInquiryStatus.bind(this);
    }

    getReply() {
        axios.get(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiry.id + '/viewReply')
            .then((res) => {
                // console.log("res",res.data.inquiries);
                this.setState({
                    replies: res.data.inquiries,
                    lastElement:  res.data.inquiries[res.data.inquiries.length-1]

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    componentDidMount() {
        this.getReply();
    }

    truncate(s) {
        if (s != null) {
            if(s.length>10){
                return s.substring(0, 10) + "...";
            }
            else {
                return s;
            }
        }
    }

    getInquiryStatus = () => {
        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/inquiries/status/' + this.props.inquiryData.id)
            .then((res) => {
                this.setState({
                    statusData: res.data,
                    statusCode: res.data.orderStatus
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    changeInquiryStatusToClosed = () => {
        axios.get(RESOURCE_BASE_URL + 'api/admin/inquiries/closed/' + this.props.inquiry.id)
            .then((res) => {
                // console.log(res.data);
                // console.log("Changed status to CLOSED");
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
        this.handleClose();
        window.location.reload();

    };

    handleClose = () => {
        this.setState({
            show : false,
        })
    };

    handleShow = () => {
        this.setState({
            show : true
        })
    };

    render() {

        let inquiryStatus = "N/A";

        if(this.props.inquiry.status === "NEW"){
            inquiryStatus = "未回答"
        }
        else if(this.props.inquiry.status === "REPLIED"){
            inquiryStatus = "回答済み"
        }
        else if(this.props.inquiry.status === "CLOSED"){
            inquiryStatus = <FormattedMessage id="app.admin-inquiry-header.close"
                                              defaultMessage="CLOSED"
                                              description=""/>
        }
        else if(this.props.inquiry.status === "UNREPLIED"){
            inquiryStatus = "未回答"
        }

        return (
            <tr>
                <td>
                    {this.props.inquiry.createdDate.substring(0,4)}年 {this.props.inquiry.createdDate.substring(5,7)}月&nbsp;
                    {this.props.inquiry.createdDate.substring(8,10)}日&nbsp;{this.props.inquiry.createdDate.substring(11,16)}
                </td>
                <td>
                    <span style={{overflow: 'hidden', textOverflow: 'hidden'}}>
                           {this.truncate(this.props.inquiry.name)}
                    </span>
                </td>
                <td>
                    <span style={{overflow: 'hidden', textOverflow: 'hidden'}}>
                           {this.truncate(this.props.inquiry.inquiryUserName)}
                        </span>
                </td>
                <td>
                     <span style={{overflow: 'hidden', textOverflow: 'hidden'}}>
                            {this.props.inquiry.subject==='QUOTATION_RELATED' ?
                                <span>お見積りに関するご質問</span>:
                                this.props.inquiry.subject==='PRODUCTION_RELATED' ?
                                    <span>製造基準・技術的に関するご質問</span>:
                                    this.props.inquiry.subject==='PRICING_RELATED' ?
                                        <span>ご注文やサービスご利用に関するご質問</span>:
                                        this.props.inquiry.subject==='PAYMENT_RELATED' ?
                                            <span>お支払いに関するご質問</span>:
                                            this.props.inquiry.subject==='QUALITY_RELATED' ?
                                                <span>出荷に関するご質問</span>:
                                                this.props.inquiry.subject === 'REQUEST' ? <text>無料基板サンプル請求</text> : <text>その他</text>

                            }
                        </span>
                </td>
                <td>
                    {inquiryStatus}
                </td>
                <td>
                    {this.props.inquiry.status === "NEW" &&
                    <h5 className="inquiry-status-view">NEW</h5>
                    }
                </td>
                <td>
                    <ViewInquiry inquiryData={this.props.inquiry} getAll={this.props.getAll} />

                    <Modal dialogClassName="message-modal" show={this.state.show} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.inquiry-reply.inquiry-close"
                                                  defaultMessage="Warning !"
                                                  description=""/>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-offset-1 data-label">

                                        <FormattedMessage id="app.inquiry-reply.inquiry-close-text"
                                                          defaultMessage="Are you sure you want to close the selected inquiry ?"
                                                          description=""/>

                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn btn-warning col-md-offset-6 col-md -2 " id="inquiry-close-btn" onClick={this.changeInquiryStatusToClosed}>
                                    <FormattedMessage id="app.common.msg-box.yes"
                                                      defaultMessage="Yes"
                                                      description=""/>
                                </button>&nbsp;&nbsp;
                                <button className="btn btn-primary col-md-offset-1 col-md -2 pull-right inquiry-cancel-btn " onClick={this.handleClose}>
                                    <FormattedMessage id="app.common.msg-box.cancel"
                                                      defaultMessage="Cancel"
                                                      description=""/>
                                </button>

                            </div>
                        </Modal.Footer>
                    </Modal>
                </td>
            </tr>

        )
    }
}

export default InquiryRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Inquiry/InquiryRow/InquiryRow.js